//交通诱导系统
const DeviceManagement = () => import(/*webpackChunkName:'operation'*/'@/page/operation/guidanceScreenSystem/deviceManagement.vue')
const SpaceInformation = () => import(/*webpackChunkName:'operation'*/'@/page/operation/guidanceScreenSystem/spaceInformation.vue')
const AnalysisChart=()=>import(/*webpackChunkName:'operation'*/'@/page/operation/guidanceScreenSystem/analysisChart.vue') 

const RouteTemp = () => import(/*webpackChunkName:'operation'*/'@/page/commons/routeTemp.vue')

export const guidanceScreenSystem={
    path: '/main/guidance-screen-system',
    name: '交通诱导系统',
    meta: {
        requireAuth: true,

    },
    component: RouteTemp,
    children: [{
        path: '/main/guidance-screen-system/device-management',
        name: '设备管理',
        meta: {
            requireAuth: true,
        },
        component: DeviceManagement
    },
    {
        path: '/main/guidance-screen-system/space-information',
        name: '车位信息',
        meta: {
            requireAuth: true,
        },
        component: SpaceInformation
    },
    {
        path: '/main/guidance-screen-system/analysis-chart',
        name: '分析图表',
        meta: {
            requireAuth: true,
        },
        component: AnalysisChart
    },
    ]
}